<template>
  <div class="joinDetail padding80">
    <Header :current="3"></Header>
    <div class="left">
      <div @click="left"><img src="../../assets/join/back.png" alt=""> &nbsp 返回职位列表</div>
    </div>
    <div class="content">
      <div class="cpjl">项目经理</div>
      <div class="xinxi">
        <div class="xinxi1"><img src="../../assets/join/local.png" alt="">&nbsp天津、杭州、台州、福州等</div>
        <div class="xinxi2"></div>
        <div class="xinxi3">全职</div>
        <div class="xinxi2"></div>
        <div class="xinxi3">本科</div>
        <div class="xinxi2"></div>
        <div class="xinxi3">若干人</div>
      </div>
      <div class="time">发布时间：2020-03-10 </div>
    </div>
    
    <div class="yq">
      <div class="title">岗位职责</div>
      <div class="thetext">1.制定项目计划并跟踪和维护，按计划完成项目，确保产品开发的实现</div>
      <div class="thetext">2.负责重大业务项目全过程项目管理工作从项目筹备。需求分析，项目规划，过程实施，结果验收，产品发布，运维，业务监控等全过程</div>
      <div class="thetext">3.负责组织项目各项评审会议及项目例会，发现并解决项目问题，有效管理项目风险</div>
      <div class="thetext">4.对内协调与组织项目资源，确保项目团队各干系人协同工作，按期交付</div>
      <div class="thetext">5.对外保持与客户畅通的沟通，做好内外部衔接工作</div>
    </div>

    <div class="yq">
      <div class="title">岗位要求</div>
      <div class="thetext">1、计算机，通信或相关专业本科以上学历</div>
      <div class="thetext">2、5年以上java开发经验或者同等项目业务经验，有大数据和项目经验和银行背景优先</div>
      <div class="thetext">3、熟悉产品开发项目流程，具备3年以上项目管理经验，主导过新产品的开发</div>
      <div class="thetext">4、善于沟通，有良好的交流和团队组织协和能力，出色的团队合作精神，抗压能力强</div>
    </div>

    <div class="yq">
      <div class="title">联系方式</div>
      <div class="thetext">如果您对我们感兴趣，请发送简历至我们的邮箱：<span> hr@leimon.com.cn</span></div>

    </div>
    <Footer></Footer>

  </div>
</template>

<script>
export default {
  name: "joinDetail",
  data() {
    return {

    };
  },
  created(){window,scrollTo(0,0)},
  mounted() {

  },
  methods: {
    left(){
      this.$router.push({name:'join'})
    }
  }
};
</script>

<style scoped lang="less">
.left{
  height: 54px;
  min-width: 900px;
  background: #FFFFFF;
  box-shadow: 0px 9px 18px 0px rgba(0, 0, 0, 0.06);
  line-height: 54px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  cursor: pointer;
  div{
    color: #666666;
    display: flex;
    width: 930px;
    margin: 0px auto;
    img{
      width: 8px;
      height: 14px;
      vertical-align: middle;
      margin-top: 20px;
    }
  }

}
.content{
    width: 900px;
    margin: 0px auto;
    background: #F7F8FA;
    padding: 20px;
    margin-top: 46px;
    font-family: PingFangSC-Semibold, PingFang SC;
    color: #141414;
    .cpjl{
      font-size: 22px;
      font-weight: bold;
    }
    .xinxi{
      margin-top: 20px;
      display: flex;
      font-family: PingFangSC-Regular, PingFang SC;
      color: #484848;
      font-size: 13px;
      .xinxi1{

        display: flex;
        img{
          width: 12px;
          height: 16px;
        }
      }
      .xinxi2{
        width: 1px;
        height: 13px;
        background: #D8D8D8;
        margin-left: 12px;
        margin-top: 3px;
      }
      .xinxi3{
        margin-left: 12px;
      }
    }
    .time{
      margin-top: 20px;
      font-size: 8px;
      font-family: PingFangSC-Regular, PingFang SC;
      color: #484848;
    }
  }
  .yq{
    width: 940px;
    margin: 0px auto;
    margin-top: 50px;
    font-family: PingFangSC-Semibold, PingFang SC;
    color: #141414;
    margin-bottom: 40px;
    .title{
      font-size: 18px;
      font-weight: bold;
      margin-bottom: 26px;
    }
    .thetext{
      font-size: 11px;
      line-height: 26px;
      span{
        font-size: 10px;
        color: #FFCF00;
      }
    }
  }
</style>
